// API Configuration for GPS Assessment System

// GPS Assessment API Gateway (separate from Leading at Gallo)
const GPS_API_URL = 'https://jmaffrrt2j.execute-api.us-west-2.amazonaws.com/prod';
const LEADING_API_URL = 'https://nh9pshlcw7.execute-api.us-west-2.amazonaws.com/prod';

// Meaningful Conversations API Gateway
export const MC_API_URL = process.env.REACT_APP_MC_API_URL || 'https://bel1gpgjh6.execute-api.us-west-2.amazonaws.com/prod';

// Use GPS API for GPS Assessment endpoints
const API_BASE_URL = process.env.REACT_APP_GPS_API_URL || GPS_API_URL;

console.log('🔧 API Configuration Loaded:', {
  gpsBaseURL: API_BASE_URL,
  leadingBaseURL: LEADING_API_URL,
  environment: process.env.NODE_ENV,
  reactAppApiUrl: process.env.REACT_APP_API_URL
});

export const API_CONFIG = {
  BASE_URL: API_BASE_URL,
  ENDPOINTS: {
    // Assessment Management
    ASSESSMENTS: '/api/assessments',
    LEADERSHIP_ASSESSMENTS: '/api/leadership-assessments',
    ASSESSMENT_DETAILS: (id) => `/api/assessments/${id}`,
    UPLOAD_URL: '/api/upload-url',
    
    // Questionnaire Management
    QUESTIONNAIRE: (id) => `/api/questionnaires/${id}`,
    SUBMIT_RESPONSE: (id) => `/api/questionnaires/${id}/responses`,
    COLLECT_RESPONSES: (id) => `/api/questionnaires/${id}/collect`,
    ANALYSIS_RESULTS: (id) => `/api/questionnaires/${id}/results`,
    GENERATE_FOLLOWUP: (id) => `/api/questionnaires/${id}/generate-followup`,
    
    // Analysis
    TRIGGER_ANALYSIS: (assessmentId) => `/api/assessments/${assessmentId}/analyze`
  },
  
  // Request timeout in milliseconds
  TIMEOUT: 30000,
  
  // Default headers
  HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
};

console.log('📋 Full API Config:', API_CONFIG);

// Environment-specific configurations
export const ENV_CONFIG = {
  development: {
    DEBUG: true,
    LOG_LEVEL: 'debug'
  },
  production: {
    DEBUG: false,
    LOG_LEVEL: 'error'
  }
};

export const getCurrentConfig = () => {
  const env = process.env.NODE_ENV || 'development';
  return ENV_CONFIG[env] || ENV_CONFIG.development;
};